import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-utils-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss']
})
export class DropDownComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: any;
  @Input() text: string;
  @Input() value: string;
  @Input() placeholder: string;
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dropdownRef') dropdownRef: ElementRef;

  dropdown: any;

  constructor() { }

  ngOnInit() {
  }

  selected(data) {
  }

  ngAfterViewInit() {
    this.initDropdown();
  }

  initDropdown() {
    if (this.dropdownRef.nativeElement) {
      this.dropdown = $(this.dropdownRef.nativeElement)
        .dropdown({
          clearable: true,
          onChange: (value: any, text: any, $selectedItem: any) => {
            this.onSelected.emit({
              value: value,
              text: text,
              selectedItem: $selectedItem,
              selectedObjec: this.data.filter((item: any) => {
                if (item[this.value].toString() === value) {
                  return item;
                }
              })[0]
            });
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      if (changes['data'].currentValue) {
        if (this.dropdown) {
          this.initDropdown();
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/drop-down/components/drop-down/drop-down.component.ts